import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-test": "pathway-progress-text"
}
const _hoisted_2 = { class: "selected-pathway" }
const _hoisted_3 = { class: "pathway-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "pathway-status" }, "Selected, no steps completed yet", -1)
const _hoisted_5 = {
  key: 1,
  "data-test": "pathway-progress-text"
}

import moment from "dayjs";
import { TeamMemberCompletedPathwayStepApiModel } from "../../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'team-member-pathway',
  props: {
    model: {},
    isCurrentPathway: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;

const displayDate = (dateString: string | undefined): string => {
  return dateString ? moment(dateString).format("DD/MM/YYYY") : "";
};

const completedPathway = (pathway: TeamMemberCompletedPathwayStepApiModel): string => {
  // Old functionality: Used to apply bold styling for completed pathways and normal styling for pathways in progress
  // return pathway.teamPathwayIsComplete ? "font-weight:bold" : "font-weight:normal";
  
  // New functionality: Always use normal font weight for all pathways regardless of completion status
  return "font-weight:normal";
};

const isPlaceholder = (pathway: TeamMemberCompletedPathwayStepApiModel): boolean => {
  return pathway.stepIndex === -1;
};

const getPathwayName = (): string => {
  // Use the pathway title as the first choice for display
  if (props.model?.cmsPathwayTitle) {
    return props.model.cmsPathwayTitle;
  }
  // Fall back to the outcome title if pathway title isn't available
  if (props.model?.cmsOutcomeTitle) {
    return `Pathway for ${props.model.cmsOutcomeTitle}`;
  }
  // Last resort fallback
  return "Active pathway";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["text-muted pathway-progress", { other: !_ctx.isCurrentPathway }]),
    style: _normalizeStyle(completedPathway(_ctx.model)),
    "data-test": "pathway-outcome-text"
  }, [
    _createTextVNode(_toDisplayString(_ctx.model.cmsOutcomeTitle) + " ", 1),
    (isPlaceholder(_ctx.model))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(getPathwayName()), 1),
            _hoisted_4
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, " Completed " + _toDisplayString(_ctx.model.cmsStepTitle) + " - " + _toDisplayString(displayDate(_ctx.model.dateCompleted)), 1))
  ], 6))
}
}

})